<template>
  <v-container fluid>
    <v-progress-linear
      v-if="$vars.loading"
      indeterminate
      class="primary--text loader"
    ></v-progress-linear>
    <!-- <v-toolbar dense flat>
      <v-spacer></v-spacer>
      <v-btn icon @click="strichTabelleUpdate(-1)"><v-icon>keyboard_arrow_left</v-icon></v-btn>
      
      <v-menu
        v-model="menu"
        :close-on-content-click="false"
        :nudge-left="65"
        :nudge-bottom="10"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-btn text v-on="on"><span class="title">{{ date | date}}</span></v-btn>
        </template>
        <v-date-picker no-title scrollable prev-icon="keyboard_arrow_left" next-icon="keyboard_arrow_right" v-model="datepicker" @input="getDatepicker" locale="de-de"></v-date-picker>
      </v-menu>

      <v-btn icon @click="strichTabelleUpdate(1)"><v-icon>keyboard_arrow_right</v-icon></v-btn>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-divider></v-divider> -->
    <v-chip small label color="green" dark>BETA</v-chip>
    <v-row class="mt-1">
      <v-col cols="12">
        <v-alert
          type="warning"
          dense
          prominent
          outlined
          text
        >
          Funktioniert noch nicht. <br>
          Die Striche werden zwar schon eingetragen. Allerdings wird noch keine Rechnung generiert.
        </v-alert>
        <v-card outlined class="mt-2 pt-2">
          <v-row>
            <v-col cols="12" md="3" class="pt-4">
              <v-autocomplete dense hide-details outlined label="Bundesbruder" :items="bundesbruderselect" v-model="neueRechnung.bbrID"></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3" class="pt-4">
              <v-text-field dense hide-details outlined label="Rechnungstitel" v-model="neueRechnung.rechnung_titel"></v-text-field>
            </v-col>
            <v-col cols="6" md="2" class="pt-4">
              <v-menu  ref="neueRechnung.datum" v-model="menu1" :close-on-content-click="false" :nudge-right="40" :return-value.sync="date" transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    dense
                    outlined
                    hide-details
                    v-model="formatDatum"
                    label="Rechnungsdatum"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker prev-icon="keyboard_arrow_left" next-icon="keyboard_arrow_right" v-model="neueRechnung.datum" locale="de-de" first-day-of-week="1" @input="menu1 = false" no-title scrollable>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="6" md="2" class="pt-4">
              <v-menu ref="neueRechnung.zahlbar_bis" v-model="menu2" :close-on-content-click="false" :nudge-right="40" :return-value.sync="date" transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    dense
                    outlined
                    hide-details
                    v-model="formatZahlbar_bis"
                    label="Zahlbar bis"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker prev-icon="keyboard_arrow_left" next-icon="keyboard_arrow_right" v-model="neueRechnung.zahlbar_bis" locale="de-de" first-day-of-week="1" @input="menu2 = false" no-title scrollable>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col class="py-0" cols="12">
              <v-textarea rows="5" v-model="neueRechnung.freitext" label="Freitext" hint="<<Rechnungstitel>>, <<Rechnungsdatum>>, <<Rechnungsnummer>>, <<Briefanrede>>, <<Vorname>>, <<Nachname>>, <<Rechnungsbetrag>>, <<Zahlbar_bis>>" auto-grow outlined></v-textarea>
            </v-col>
          </v-row>
        </v-card>
        <v-card outlined class="my-4 py-4">
          <v-row>
            <v-col cols="12" sm="4" md="2">
              <v-autocomplete dense hide-details outlined label="EKP-Getränke" :items="getrankeselect" v-model="ekp"></v-autocomplete>
            </v-col>
            <v-col cols="4" sm="3" md="2">
              <v-text-field dense hide-details outlined class="feld" name="" label="Anzahl Getränke" id="" v-model="ekp_anzahl"></v-text-field>
            </v-col>
            <v-col cols="4" sm="3" md="2">
              <v-text-field dense hide-details outlined class="feld" name="" label="Pauschal" id="" v-model="pauschal"></v-text-field>
            </v-col>
            <v-col cols="8" sm="5" md="2">
              <v-text-field dense hide-details outlined class="feld" name="" label="Grund" id="" v-model="grund"></v-text-field>
            </v-col>
            <v-col cols="8" sm="5" md="4">
              <v-btn large dark class="primary" @click="addItem"><v-icon>add</v-icon></v-btn>
            </v-col>
          </v-row>
          <v-divider class="mt-4"></v-divider>
          <v-simple-table fixed-header height="calc(100vh - 510px)" dense>
            <thead>
              <tr>
                <th>Was</th>
                <th>Anzahl</th>
                <th class="text-right">Preis</th>
                <th width="20px"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in items" :key="item.name">
                <td>{{ item.was }}</td>
                <td>{{ item.anzahl }}</td>
                <td class="text-right">{{ item.preis | money }}</td>
                <td @click="deleteStrich(item)"><v-icon>delete</v-icon></td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card>
        <v-card outlined>
          <v-card-title>
            <v-spacer></v-spacer>
            Summe: {{ summe | money }}
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="8" class="">
        <v-alert
          type="info"
          dense
          prominent
          outlined
          text
        >
          Die Rechnung wird als Entwurf gespeichert. Und kann im Menü Rechnungen versendet werden.<br>
          Getränke werden direkt in der Schankverlustrechnung berücksichtigt.
        </v-alert>
      </v-col>
      <v-col cols="4" class="pt-4 text-right">
        <v-btn disabled x-large block dark class="primary" @click="saveItem">Rechnung speichern</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    props: ['props'],
    data () {
      return {
        neueRechnung: {
          bbrbbr: [],
          titel: '',
          datum: new Date().toISOString().substr(0, 10),
          zahlbar_bis: new Date(new Date().setDate(new Date().getDate() + 14)).toISOString().substr(0, 10),
          freitext: '<<Briefanrede>> <<Nachname>>, \n\nhiermit bitte ich Dich die Rechnung <<Rechnungsnummer>> in Höhe von <<Rechnungsbetrag>>€ bis zum <<Zahlbar_bis>> zu überweisen. \n \nMit bundesbrüderlichen Grüßen \nThomas Wieczorek \nBierwart',
          freitext_Sepa: '<<Briefanrede>> <<Nachname>>, \n\nhiermit informiere ich Dich, dass die Rechnung <<Rechnungsnummer>> in Höhe von <<Rechnungsbetrag>>€ am <<Zahlbar_bis>> von Deinem Konto abgebucht wird. \n \nMit bundesbrüderlichen Grüßen  \nThomas Wieczorek \nBierwart',
          positionen: [],
          kasse: 'Bierkasse',
          status: 'Entwurf'
        },
        menu1: '',
        menu2: '',
        date: new Date(),
        datepicker: new Date().toISOString().substr(0, 10),
        pauschal: '',
        getrankeselect: [],
        striche: '',
        items: [],
        grund: '',
        bbrID: '',
        ekp: '',
        ekp_anzahl: '',
        stricheheute: [],
        menu: false
      }
    },
    computed: {
      formatDatum () {
        if (!this.neueRechnung.datum) return null
        return new Date(this.neueRechnung.datum).toLocaleString(['de-de'], {month: 'short', weekday: 'short', day: 'numeric', year: '2-digit'})
      },
      formatZahlbar_bis () {
        if (!this.neueRechnung.zahlbar_bis) return null
        return new Date(this.neueRechnung.zahlbar_bis).toLocaleString(['de-de'], {month: 'short', weekday: 'short', day: 'numeric', year: '2-digit'})
      },
      summe () {
        let summe = 0
        this.items.forEach(item => {
          summe = parseFloat(summe) + parseFloat(item.preis)
        })
        return summe
      },
      bundesbruderselect () {
        let items = this.$store.state.bbrbbr.bbrbbr
        let bbrbbr = []
        items.forEach(item => {
          if (item.vulgo) {
            bbrbbr.push({
              value: item.id,
              text: item.nachname + ', ' + item.vorname + ' (' + item.vulgo + ')'
            })
          } else {
            bbrbbr.push({
              value: item.id,
              text: item.nachname + ', ' + item.vorname
            })
          }
        })
        return bbrbbr
      }
    },
    methods: {
      addItem () {
        if (this.pauschal) {
          this.items.push({
            art: 'pauschal',
            was: this.grund,
            anzahl: 'pauschal',
            grund: this.grund,
            preis: this.pauschal,
            status: ''
          })
        }
        if (this.ekp) {
          this.items.push({
            art: 'ekp',
            was: this.ekp[0].bezeichnung,
            ekp: this.ekp,
            anzahl: this.ekp_anzahl,
            preis: this.ekp[0].preis * this.ekp_anzahl,
            status: ''
          })
        }
        this.ekp = ''
        this.ekp_anzahl = ''
        this.pauschal = ''
        this.grund = ''
      },
      saveItem () {
        this.items.forEach(item => {
          let eintrag
          if (item.art === 'ekp') {
            eintrag = {
              bbrID: this.bbrID,
              art: 'ekp',
              ekp: item.ekp,
              date: this.date,
              preis: item.ekp[0].preis,
              anzahl: 1,
              status: 'berechnet',
              grund: item.ekp[0].bezeichnung
            }
            for (let i = 1; i <= item.anzahl; i++) {
              this.$store.dispatch('striche/createStrich', eintrag)
            }
          }
          if (item.art === 'pauschal') {
            eintrag = {
              bbrID: this.bbrID,
              art: 'pauschal',
              preis: item.preis,
              date: this.date,
              grund: item.grund,
              anzahl: 1,
              status: 'berechnet'
            }
            this.$store.dispatch('striche/createStrich', eintrag)
          }
        })
        this.ekp = ''
        this.ekp_anzahl = ''
        this.pauschal = ''
        this.grund = ''
        this.items = []
      },
      deleteStrich (value) {
        this.items.splice(this.items.indexOf(value), 1)
      },
      getDatepicker () {
        this.date = new Date(this.datepicker)
        this.datepicker = new Date(this.date).toISOString().substr(0, 10)
        this.menu = false
      }
    },
    beforeMount () {
      this.$firebase.firestore().collection('vereine').doc(this.$vars.verbindung).collection('getranke').orderBy('bezeichnung').onSnapshot(querySnapshot => {
        querySnapshot.forEach(doc => {
          this.getrankeselect.push({
            value: [{
              id: doc.id,
              preis: doc.data().verkauf1,
              bezeichnung: doc.data().bezeichnung
            }],
            text: doc.data().bezeichnung
          })
        })
      }, err => {
        console.log(`Encountered error: ${err}`)
      })
    }
  }
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// bierwartVeranstaltungAbrechnen.vue?d5f3615a